module.exports = __webpack_public_path__ + "img/sup_deposit_vega1.7c3a9c57.jpg";